import { render, staticRenderFns } from "./ConsolidatedReportPage.vue?vue&type=template&id=6065a370&scoped=true&"
import script from "./ConsolidatedReportPage.vue?vue&type=script&lang=js&"
export * from "./ConsolidatedReportPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsolidatedReportPage.vue?vue&type=style&index=0&id=6065a370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065a370",
  null
  
)

export default component.exports